/* eslint-disable max-len */
export const howItWorksData = [
  {
    id: 1,
    title: 'Enter your measurements',
    text: 'We will guide you through the process of entering measurements for the rooms where you want new carpet installed. A measure technician will verify your measurements later.',
  },
  {
    id: 2,
    title: 'Choose your carpet and get an instant estimate',
    text: 'Select from a wide assortment of carpet to fit your room, lifestyle and budget. Once you\'ve entered your room measurements and selected your carpet, we\'ll provide you with an instant estimate for you carpet installation project.',
  },
  {
    id: 3,
    title: 'You decide what\'s next',
    text: 'Complete your entire order online, and we\'ll send a technician to your home to collect precise digital measurements of your flooring area. Or you can save your estimate and schedule your measure before buying your carpet.',
  }
];
